import { render, staticRenderFns } from "./Animation.vue?vue&type=template&id=38b84eb4&scoped=true"
import script from "./Animation.vue?vue&type=script&lang=js"
export * from "./Animation.vue?vue&type=script&lang=js"
import style0 from "./Animation.vue?vue&type=style&index=0&id=38b84eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../app/browser@vue-cli/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b84eb4",
  null
  
)

export default component.exports